import React from 'react';
import { Button } from '../ui/button';
import { Calendar } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const OnboardingCTA = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-gray-950 to-gray-900">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-br from-blue-900/30 via-indigo-900/30 to-purple-900/30 rounded-3xl p-12 border border-blue-800 text-center relative overflow-hidden">
          {/* Glow effect */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.1),transparent_70%)]" />
          
          <div className="relative z-10">
            <Button
              size="lg"
              onClick={openCalendly}
              className="bg-blue-600 hover:bg-blue-700 text-lg px-10 py-6"
            >
              <Calendar className="w-5 h-5 mr-2" />
              Schedule a Call
            </Button>
          </div>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default OnboardingCTA;
